import moment from 'moment';

export default function toDate(date) {
    if (date) {
        return moment(date).locale('en').format('MM/DD/YYYY');
    }
}
